import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { RoleSettingSelect } from './RoleSettingSelect';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import { rolesSettingsKeys } from '../../../../services/pcwService';
import { documentsByKey } from '../../../../pages/Prequal/constants';
import _ from 'lodash';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export function DocumentsByTypeSettings({
  settings,
  itemConfiguration,
  setItemConfiguration,
  itemType,
  extraData,
}: any) {
  const classes = useStyles();
  const getValue = () => {};

  const updateValue = (e: any, value: any) => {};

  const data = _.orderBy(
    _.map(itemConfiguration.documentsByTypeSettings, (item, key) => {
      return {
        key,
        rolesSettings: item.rolesSettings,
        text: _.get(documentsByKey[key], 'text', ''),
      };
    }),
    'text'
  );

  const updateRolesSettingsHiddenValue = (value: any, key: any, docTypeKey: string | number) => {
    setItemConfiguration((prevItemConfiguration: { [x: string]: { [x: string]: { rolesSettings: any } } }) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: {
          ...prevItemConfiguration[settings.configurationKey],
          [docTypeKey]: {
            ...prevItemConfiguration[settings.configurationKey][docTypeKey],
            rolesSettings: {
              ...prevItemConfiguration[settings.configurationKey][docTypeKey].rolesSettings,
              [key]: value,
            },
          },
        },
      };
    });
  };

  const handleHiddenForLendersChange = (checked: boolean, docTypeKey: string | number) => {
    setItemConfiguration((prevItemConfiguration: { [x: string]: { [x: string]: any } }) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: {
          ...prevItemConfiguration[settings.configurationKey],
          [docTypeKey]: {
            ...prevItemConfiguration[settings.configurationKey][docTypeKey],
            hiddenForLenders: checked,
          },
        },
      };
    });
  };

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Document Type</TableCell>
            <TableCell align="center">Hidden By User Roles</TableCell>
            <TableCell align="center">Hidden For Lender</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(row => {
            const documentTypeSettings = _.get(itemConfiguration, `${settings.configurationKey}.${row.key}`);
            return (
              <TableRow key={row.key}>
                <TableCell component="th" scope="row">
                  {row.text}
                </TableCell>
                <TableCell>
                  <RoleSettingSelect
                    rolesSettingsSelected={documentTypeSettings.rolesSettings[rolesSettingsKeys.hidden]}
                    rolesSettingsSelectedKey={rolesSettingsKeys.hidden}
                    updateRolesSettingsValue={_.partialRight(updateRolesSettingsHiddenValue, row.key)}
                    isHideHelperText={true}
                  />
                </TableCell>
                <TableCell component="th" scope="row" align="center">
                  <Checkbox
                    checked={documentTypeSettings.hiddenForLenders}
                    onChange={event => handleHiddenForLendersChange(event.target.checked, row.key)}
                    color="primary"
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
